import { useParams } from "react-router-dom";
import { useMarketMap } from "./market/useMarketMap";
import { MarketHeader } from "./market/MarketHeader";
import { MarketFilters } from "./market/MarketFilters";
import { MarketTable } from "./market/MarketTable";

const MarketView = () => {
  const { userId } = useParams();
  const m = useMarketMap(userId);
  return (
    <div className="max-w-7xl mx-auto" data-testid="market-view">
      <MarketHeader stats={m.stats} job={m.job} onExpand={m.expand} />
      <MarketFilters filters={m.filters} setFilters={m.setFilters} stats={m.stats} total={m.total} />
      <MarketTable firms={m.firms} loading={m.loading} onStatus={m.setStatus} onHunt={m.huntHere} hunting={m.hunting} empty={!m.stats || m.stats.total === 0}
        hasMore={m.hasMore} loadingMore={m.loadingMore} onLoadMore={m.loadMore} />
    </div>
  );
};

export default MarketView;
